import { LockKeyhole, Radar, Search, ShieldCheck } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { EmptyState, ErrorState, LoadingState } from "../components/StateViews";
import { useEstufaData } from "../lib/queries";

export function RadarPage() {
  const query = useEstufaData();
  if (query.isLoading) return <LoadingState />;
  if (query.isError || !query.data) return <ErrorState />;
  return (
    <>
      <PageHeader
        eyebrow="Pesquisa disciplinada"
        title="Radar"
        description="A infraestrutura existe, mas nenhuma nova Seed é iniciada sem autorização e estudo completo."
      />
      <div className="notice-card notice-card--locked">
        <div className="notice-icon">
          <LockKeyhole size={24} />
        </div>
        <div>
          <strong>Seed #002 está bloqueada</strong>
          <p>
            Não pesquisar, pontuar, cadastrar candidato ou iniciar código nesta fase. A Seed 001
            precisa entrar em homologação/publicação primeiro.
          </p>
        </div>
      </div>
      <div className="dashboard-grid">
        <section className="chart-card">
          <div className="card-heading">
            <div>
              <h3>Pipeline futuro</h3>
              <p>Estrutura da fábrica, ainda sem candidato ativo.</p>
            </div>
          </div>
          <div className="radar-pipeline">
            {[
              "Dores detectadas",
              "Investigadas",
              "Com evidência",
              "API-feasible",
              "Candidatas",
              "Construídas",
            ].map((label, index) => (
              <div className="pipeline-step" key={label}>
                <div className="pipeline-number">{index + 1}</div>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </section>
        <section className="chart-card">
          <div className="card-heading">
            <div>
              <h3>Princípios de seleção</h3>
              <p>O score nunca pode esconder distribuição ruim.</p>
            </div>
          </div>
          <div className="principle-list">
            <div>
              <Search size={18} />
              <span>Winners, losers reais e low-traction aparentemente bons.</span>
            </div>
            <div>
              <Radar size={18} />
              <span>Product, Distribution, Platform Risk e Build Score separados.</span>
            </div>
            <div>
              <ShieldCheck size={18} />
              <span>Dado observado, inferência e hipótese nunca misturados.</span>
            </div>
          </div>
        </section>
      </div>
      {query.data.researchApps.length === 0 ? (
        <EmptyState
          title="Dataset de pesquisa vazio por decisão"
          description="Isso é esperado. O Radar está pronto, mas a próxima pesquisa ainda não começou."
        />
      ) : (
        <section className="table-card">
          <div className="card-heading">
            <div>
              <h3>Apps pesquisados</h3>
              <p>Registros históricos já autorizados.</p>
            </div>
          </div>
          <div className="responsive-table">
            <table>
              <thead>
                <tr>
                  <th>App</th>
                  <th>Developer</th>
                  <th>Categoria</th>
                  <th>Reviews</th>
                  <th>Rating</th>
                  <th>Preço inicial</th>
                </tr>
              </thead>
              <tbody>
                {query.data.researchApps.map((app) => (
                  <tr key={app.id}>
                    <td>
                      <strong>{app.appName}</strong>
                    </td>
                    <td>{app.developer ?? "—"}</td>
                    <td>{app.category ?? "—"}</td>
                    <td>{app.reviewsCount ?? "—"}</td>
                    <td>{app.rating ?? "—"}</td>
                    <td>{app.priceLowestPaid ?? "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </>
  );
}
